import React from 'react'
import styled from 'styled-components'
import _ from 'lodash'

import { themeColor } from '../theme'
import { Title, Text } from '../Text'
import { Button } from '../Button'

const ShapeWithIconWrapper = styled.div<{ iconPosition?: string }>`
  z-index: 0;
  width: 80px;
  height: 80px;
  position: absolute;
  ${({ iconPosition }) => (_.includes(iconPosition, 'top') ? 'top: 0;' : null)}
  ${({ iconPosition }) => (_.includes(iconPosition, 'bottom') ? 'bottom: 0;' : null)}
  ${({ iconPosition }) => (_.includes(iconPosition, 'right') ? 'right: 0;' : null)}
  ${({ iconPosition }) => (_.includes(iconPosition, 'left') ? 'left: 0;' : null)}
  transform: translateY(-30%);

  .yellow {
    width: 80px;
    height: 80px;
    transform: rotate(-45deg);
    border-radius: 4px;
    background-color: ${({ theme }) => theme.colors.secondary};
    position: absolute;
    ${({ iconPosition }) => (iconPosition ? null : 'display: none')}
  }

  .orange {
    width: 25px;
    height: 25px;
    transform: rotate(-315deg);
    border-radius: 4px;
    background-color: ${({ theme }) => theme.colors.pumpkinOrange};
    position: absolute;
    bottom: -18%;
    right: 56%;
    ${({ iconPosition }) => (iconPosition ? null : 'display: none')}
  }

  .blue {
    width: 14px;
    height: 14px;
    transform: rotate(-315deg);
    border-radius: 2px;
    background-color: ${({ theme }) => theme.colors.primary};
    position: absolute;
    bottom: 0%;
    left: -13%;
    ${({ iconPosition }) => (iconPosition ? null : 'display: none')}
  }

  svg,
  img {
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(-50%, 50%);
    ${({ iconPosition }) => (iconPosition ? null : 'display: none')}
  }
`

type ShapeProps = {
  children?: React.ReactNode
  iconPosition?: string
}

export const Shape = ({ iconPosition, children }: ShapeProps) => (
  <ShapeWithIconWrapper iconPosition={iconPosition}>
    <div className="yellow" />
    <div className="orange" />
    <div className="blue" />
    {children}
  </ShapeWithIconWrapper>
)

const LinkButtonWrapper = styled.a`
  display: inline-flex;
`

const Wrapper = styled.div<{ marginTop?: string }>`
  margin-top: ${({ marginTop }) => marginTop || '40px'};
  background-color: ${themeColor('bgPrimary')};
  position: relative;
  padding: 40px;
  width: 100%;
  border-radius: 4px;
`

type InfoBoxWithButtonIconProps = {
  title: string
  text: React.ReactNode
  link?: { url: string; text: string; target?: string }
  button?: {
    text: string
    onClick: () => void
  }
  icon?: React.ReactNode
  marginTop?: string
  iconPosition?: string
}

export const InfoBoxWithButtonIcon = ({
  title,
  text,
  button,
  link,
  icon,
  marginTop,
  iconPosition
}: InfoBoxWithButtonIconProps) => (
  <Wrapper marginTop={marginTop}>
    <Shape iconPosition={iconPosition}>{icon}</Shape>
    <Title level="medium" padding={{ right: '60px' }}>
      {title}
    </Title>
    <Text block mt={3} mb="40px">
      {text}
    </Text>
    {button && (
      <Button variant="primary" onClick={button.onClick}>
        {button.text}
      </Button>
    )}
    {link && (
      <LinkButtonWrapper href={link.url} target={link.target}>
        <Button variant="primary">{link.text}</Button>
      </LinkButtonWrapper>
    )}
  </Wrapper>
)
